import React, {useContext} from 'react';
import InputHandle from "../basic/InputHandle";
import OutputHandle from "../basic/OutputHandle";
import NodeView from "./NodeView";
import {MediaContext} from "../media/MediaContext";


export default function DoNode({id, data, selected}) {
    const {flowId, nodeHighlighting} = useContext(MediaContext)

    return (
        <NodeView id={id} data={data} selected={selected} disabled={flowId == 'showFlow'} nodeHighlighting={nodeHighlighting[id]}>
            <InputHandle nodeHighlighting={nodeHighlighting[id]}/>
            <OutputHandle id='output' position={28} nodeHighlighting={nodeHighlighting[id]}/>
        </NodeView>
    )
}